"use strict";
var ɵngcc0 = require('@angular/core');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var models_1 = require("../models/models");
var AssetUrl = /** @class */ (function () {
    // default current otherwise a version number
    function AssetUrl() {
    }
    AssetUrl.prototype.transform = function (assetFile, urlType, renderType, version, mode, width, height, backgroundColor) {
        if (urlType === void 0) { urlType = "download"; }
        if (renderType === void 0) { renderType = "AssetsFriendly"; }
        if (version === void 0) { version = "current"; }
        if (mode === void 0) { mode = models_1.ThumbnailGenerationMode.PAD; }
        if (width === void 0) { width = null; }
        if (height === void 0) { height = null; }
        if (backgroundColor === void 0) { backgroundColor = null; }
        if (assetFile && assetFile.versionCurrent) {
            if (urlType.toLowerCase() == "thumbnail")
                return this.generateThumb(assetFile, renderType, mode, version, width, height, backgroundColor);
            var versionToUse = this.getVersion(assetFile, version);
            var versionRender = this.getUrlByRenderType(assetFile, renderType, versionToUse);
            var url = versionRender.url + "?v" + versionToUse.assetFile;
            // Only allow this if the assetFile is a AssetDocumentFile, otherwise can get TS errors.
            if (this.isDocumentType(assetFile) && urlType.toLowerCase() == "preview") {
                switch (assetFile.format.id) {
                    case models_1.DocumentFileFormat.DOC.id:
                    case models_1.DocumentFileFormat.DOCX.id:
                    case models_1.DocumentFileFormat.XLS.id:
                    case models_1.DocumentFileFormat.XLSX.id:
                    case models_1.DocumentFileFormat.PPT.id:
                    case models_1.DocumentFileFormat.PPS.id:
                    case models_1.DocumentFileFormat.PPSX.id:
                    case models_1.DocumentFileFormat.PPTX.id:
                        return "http://view.officeapps.live.com/op/view.aspx?src=" + encodeURI(url);
                    case models_1.DocumentFileFormat.UNKNOWN.id:
                    case models_1.DocumentFileFormat.XML.id:
                    case models_1.DocumentFileFormat.PDF.id:
                        return url;
                    default:
                        return url;
                }
            }
            return url;
        }
        return null;
    };
    AssetUrl.prototype.parseVersion = function (version) {
        if (typeof version == "string") {
            var parse = parseInt(version);
            if (!isNaN(parse)) {
                return parse;
            }
            else {
                return 0; // If string that isn't a number, treat as current
            }
        }
        else {
            return version;
        }
    };
    AssetUrl.prototype.getVersion = function (assetFile, version) {
        var versionNum = this.parseVersion(version);
        var usedVersion;
        if (versionNum > 0) {
            usedVersion = assetFile.versionsPrevious.find(function (x) { return x.assetFile == versionNum; });
        }
        if (usedVersion == null)
            usedVersion = assetFile.versionCurrent;
        return usedVersion;
    };
    AssetUrl.prototype.getUrlByRenderType = function (assetFile, renderType, version) {
        var localRenderType = models_1.RenderType.FromId(renderType);
        return version.urls.find(function (u) { return u.renderType.id == localRenderType.id; });
    };
    AssetUrl.prototype.generateThumb = function (assetFile, renderType, mode, version, width, height, backgroundColor) {
        if (renderType === void 0) { renderType = "AssetsFriendly"; }
        if (mode === void 0) { mode = models_1.ThumbnailGenerationMode.PAD; }
        if (version === void 0) { version = "current"; }
        if (width === void 0) { width = null; }
        if (height === void 0) { height = null; }
        if (backgroundColor === void 0) { backgroundColor = null; }
        var versionToUse = this.getVersion(assetFile, version);
        var versionRender = this.getUrlByRenderType(assetFile, renderType, versionToUse);
        if ((assetFile.type.id == models_1.AssetType.Image.id) || // If Image
            (assetFile.type.id == models_1.AssetType.Document.id && assetFile.format.id == models_1.DocumentFileFormat.PDF.id)) { // Or PDF
            var dimensionStr = "";
            if (typeof mode == "string") {
                var thumbnailMode = models_1.ThumbnailGenerationMode.FromId(mode);
                if (thumbnailMode == null)
                    thumbnailMode = models_1.ThumbnailGenerationMode.PAD;
            }
            else {
                thumbnailMode = mode;
            }
            // We want to set defaults if params are null
            if (width == null && height == null) {
                width = 400;
                height = 400;
            }
            if (mode == models_1.ThumbnailGenerationMode.SQUARECROP && width != null && height != null)
                height = null;
            if (width != null && height != null) {
                dimensionStr = width.toString() + "x" + height.toString();
            }
            else {
                if (width != null)
                    dimensionStr = width.toString();
                else
                    dimensionStr = height.toString();
            }
            if (backgroundColor != null)
                backgroundColor = "_" + backgroundColor;
            else
                backgroundColor = "";
            var newUrl = versionRender.url + "_" + thumbnailMode.id.toLowerCase() + backgroundColor + "_" + dimensionStr + "_thumb.jpg?v" + versionToUse.assetFile;
            return newUrl;
        }
        else {
            return versionRender.thumbnailUrl + "?v" + assetFile.versionCurrent.assetFile;
        }
    };
    AssetUrl.prototype.isDocumentType = function (obj) {
        return obj.format !== undefined;
    };
AssetUrl.ɵfac = function AssetUrl_Factory(t) { return new (t || AssetUrl)(); };
AssetUrl.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "AssetUrl", type: AssetUrl, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AssetUrl, [{
        type: core_1.Pipe,
        args: [{ name: "AssetUrl" }]
    }], function () { return []; }, null); })();
    return AssetUrl;
}());
exports.AssetUrl = AssetUrl;

